<template>
  <div class="header" id="tinyScreenHeader">
    <div class="container pcShow" style="position: relative; padding-top: 5px;">
      <img @click="goHome" class="logo" height="62px;" src="../../assets/picture/logo.png">
      <div class="navBox">
        <!-- <el-menu
          mode = "horizontal"
          router  
          :default-active = "path"  
          class = "el-menu-demo">
        <template v-for="(item, index) in nav_menu_data">
          <el-menu-item :index = "item.path" :key = "index">
            <el-submenu v-if="item.subNav" index="2">
              <template slot="title"  @click="about">{{item.title}}</template>
              <el-menu-item v-for="(sub,num) in item.subNav"  :index = "sub.path" :key="num">{{sub.title}}</el-menu-item>
            </el-submenu>
            <span v-else>{{item.title}}</span>
          </el-menu-item>
        </template>
    </el-menu> -->

      <ul class="navMenu">
        <li class="navMenu_li"  v-for="(item, index) in nav_menu_data" :key = "index" >
          <!-- @mouseenter="enter(index)" @mouseleave="leave(index)" -->
          <span  @click="goPage(item,index,'pc')" :class="navIndex == index?'isActive':''">{{item.title}}</span>
          <!-- :class="navIndex == index?'isActive':''" -->
         <!--  <ul class="navSubMenu" v-if="navIndex == index && isShow">
            <li class="navSubMenu_li" @click="gosubPage(sub,'pc')" v-for="(sub,num) in item.subNav" :key="num">
              {{sub.title}}
            </li>
          </ul> -->
        </li>
      </ul>
      <div class="mt30 searchCon" v-clickoutside="handleClose">
        <i @click="showSearch" class="searchIcon mr42">
          <img class="fl" width="22px" src="../../assets/picture/homePic/search-icon.png">
        </i>
        <div v-if="show" class="searchBox">
          <input type="text" v-model="fromData.keyword" :placeholder="$t('search.placeholder')" name="">
          <img @click="deleteKeyword" class="deleteIcon" height="62px" src="../../assets/picture/close.png">
          <span class="search" @click="handleSearch">{{$t('search.btn')}}</span>
        </div>
      </div>
        <div class="changeLangage">
          <span :class="lang == 'cn'?'isLang':''" @click="changeLangage('cn')">CN</span>|<span  :class="lang == 'en'?'isLang':''" @click="changeLangage('en')">EN</span>
        </div>
      </div>
    </div>
    <div class="phoneNav phoneShow" id="phoneNav">
      <div class="headerNav">
        <img height="45px" class="logo" style="padding-top: 5px;" @click="goHome" src="../../assets/picture/logo.png">
        <img class="navIcon" v-if="!isShowNav" @click="isShowNav =!isShowNav"  src="../../assets/picture/phone/nav.png">
        <img class="navIcon closeIcon" v-else @click="isShowNav =!isShowNav" src="../../assets/picture/phone/close.png">
      </div>
      <div class="containNav" v-if="isShowNav">
        <div class="searchBox">
          <img height="60%"  @click="handleSearch" src="../../assets/picture/phone/search.png">
          <input type="text" v-model="fromData.keyword" :placeholder="$t('search.placeholder')" name="">
        </div>
        <div class="navBox">
          <ul class="firstUl">
            <li class="firstLi"  v-for="(item,index) in nav_menu_data" :key="index">
              <span @click="goPage(item,index,'phone')" :class="navIndex == index?'isActive':''">
                {{item.title}}
              </span>
              <!-- <ul class="secondUl" v-if="item.subNav">
                <li class="secondLi" @click="gosubPage(dot,'phone')" v-for="(dot,num) in item.subNav" :key="num">
                  <span>{{dot.title}}</span>
                </li>
              </ul> -->
            </li>
          </ul>
          <div class="changeLangage">
          <span :class="lang == 'cn'?'isLang':''" @click="changeLangage('cn')">CN</span>|<span  :class="lang == 'en'?'isLang':''" @click="changeLangage('en')">EN</span>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
      function documentHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
              return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
              // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
              binding.value(e);
          }
      }
      // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
      el.__vueClickOutside__ = documentHandler;
      document.addEventListener('click', documentHandler);
  },
  update() {},
  unbind(el, binding) {
      // 解除事件监听
      document.removeEventListener('click', el.__vueClickOutside__);
      delete el.__vueClickOutside__;
  },
};
export default {
  name: 'Header',
  data() {
    return {
      lang:'',
      height:0,
      isShowNav:false,
      isShow:true,
      navIndex:-1,
      keyWord:'',
      path: '',
       fromData:{
          pageNum:1,
          pageSize:10,
          keyword:''
      },
      nav_menu_data: [
        // {
        //   title: this.$t('nav.about'),
        //   path: '/about',
        //   phonePath:'/about',
        //   subNav:[
        //     {
        //       title: this.$t('nav.story'),
        //       path: '/story',
        //       phonePath:'/story',
        //     },
        //   ]
        // },
        //  {
        //   title: this.$t('nav.occupation'),
        //   path: '/careers',
        //   phonePath:'/careers',
        //   subNav:[
        //     {
        //       title: this.$t('nav.positions'),
        //       path: '/positions',
        //       phonePath:'/positions',
        //     },
        //     {
        //       title: this.$t('nav.careers'),
        //       path: '/campus2021',
        //       phonePath:'/campus2021',
        //     },
        //     // {
        //     //   title: '冬令营',
        //     //   path: '/winterCamp'
        //     // },
        //     // {
        //     //   title: '佳油站',
        //     //   path: '/'
        //     // },
        //   ]
        // }, 
        // {
        //   title:  this.$t('nav.product'),
        //   path: '/product',
        //   phonePath:'/phoneAggrement',
        // },
        // {
        //   title: this.$t('nav.responsibility'),
        //   path: '/responsibility',
        //   phonePath:'/responsibility',
        // },
        // {
        //   title: this.$t('nav.contact'),
        //   path: '/contact',
        //   phonePath:'/contact',
        // },
      ],
      activeIndex: '1',
     show:false,
    };
  },
  directives: {clickoutside},
  created () {  
    this.onRouteChanged();  
    this.getNavigation();
    this.lang =window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'';
  },
  computed: {
    // 滚动区高度 
    scrollerHeight: function() {
      return (window.innerHeight) + 'px'; //自定义高度需求
    },
  },
  mounted() {
    let index = localStorage.getItem('navIndex');
    this.navIndex = index?index:-1;
    this.height =  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  },
  methods: {
    goPage(item,index,type){
      if(item.tag){
        console.log(item.path,'item.path')
        // window.open(item.path);
        window.location.href=item.path;
      }else{
        this.navIndex = index;
        localStorage.setItem('navIndex',index);
        localStorage.setItem('navName',item.title);   
        this.$router.push(item.path);  
      }
    },
    gosubPage(item,type){
      localStorage.setItem('navSubName',item.title);
      if(type == 'phone'){
         this.$router.push({  
            path: item.path    
        }) 
      }else{
         this.$router.push({  
            path: item.path    
        }) 
      }
    },
    changeLangage(lang) {
        this.$i18n.locale=lang   //设置中英文模式
        localStorage.setItem('language',this.$i18n.locale);
        window.sessionStorage.setItem("language", lang);
        let path = this.$route.path;
        if(path == '/socialDetail' || path == '/positions'){
          this.$router.push({  
            path: '/positions'   
          });
          location.reload();
        }else{
           location.reload();
        }
    },
    handleSearch(){
      window.sessionStorage.setItem('keyword',this.fromData.keyword);
      this.$router.push({  
            path: '/search',  
            query: {   
                keyword: this.fromData.keyword,   
            }   
        })
    },
    enter(index){
      this.navIndex = index;
      this.isShow = true;
    },
    leave(index){
      this.navIndex = -1;
      this.isShow = false;
    },
    handleClose(e) {
      this.show = false;
    },
    onRouteChanged () {
      let that = this
      that.path  = that.$route.path
    },
    showSearch(){
      this.show = !this.show;
    },
    goHome(){
      this.$router.push({  
            path: '/'  
        });
      this.navIndex = -1;
      localStorage.setItem('navIndex',this.navInde);
    },
    deleteKeyword(){
      this.fromData.keyWord = '';
    },
     //获取基础配置信息
    async getNavigation() {
      this.nav_menu_data = [];
        const { data: res } = await this.$http.get("/navigation/getNavigation.do?languageType="+this.lang);
        if (res.code !== 200) return this.$message.error(res.message);
        let list = res.data;
        if(this.lang === 'en'){
          list.map(e=>{
            let item = {
              title:  e.navigationEnName,
              path: e.url,
            }
            this.nav_menu_data.push(item);
          })  
          // let newItem = {
          //     title:  'BEWARE OF SCAMS',
          //     path: 'https://mp.weixin.qq.com/s/js0bXVDKRlH1dNBnAw3kfA',
          //     tag:1
          // }  
          // this.nav_menu_data.push(newItem)     
        }else{
           list.map(e=>{
            let item = {
              title:  e.navigationName,
              path: e.url,
            }
            this.nav_menu_data.push(item);
          })  
            let newItem = {
              title:  '谨防被骗',
              path: 'https://mp.weixin.qq.com/s/js0bXVDKRlH1dNBnAw3kfA',
              tag:1
          }  
          this.nav_menu_data.push(newItem) 
        }
      },
  }
};
</script>

<style lang="less" scoped>
  /deep/ .el-submenu__title:hover{
    background-color: #fff !important;
  }

  .isLang{
    color:#353535 !important;
  }
  .searchCon{
    position: absolute;
    right: 65px;
  }
  .isActive{
    /*border-bottom:1px solid #A70012;*/
    color: #353535 !important;
  } 
 .header{
   z-index: 99;
    img{
    float: left;
  }
  .navMenu{
     float: right;
     display: flex;
    z-index: 200;
    position: absolute;
    right: 160px;
    top: 50px;
    .navMenu_li{
      /* height: 300px; */
 /*     width:68px;*/
      margin:0 18px;
      float: left;
      padding-bottom: 4px;
      position: relative;
      cursor: pointer;
      span{
        width: 68px;
        height: 30px;  
        color: #9A9A9A;    
        letter-spacing: 1px;
        padding-bottom: 8px;
      }
      .navSubMenu{
        position: absolute;
        top:25px;
        overflow: hidden;
        width: 300px;
        padding:16px 0;
        .navSubMenu_li:first-of-type{
          padding-top:32px;
        };
        .navSubMenu_li:last-of-type{
          padding-bottom:32px;
        };
        .navSubMenu_li:hover{
          color: #900211;
        }
        .navSubMenu_li{
          cursor: pointer;
          width: 230px;
          padding-left: 30px;
          padding-top:16px;
          padding-bottom: 16px;
          background: #F0F0F2;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          letter-spacing: 1px;
          display: inline-block;
        }
      }
    }
   

  }
  .mt30{
    margin-top: 49px;
  }
  /deep/ .el-menu--horizontal>.el-menu-item{
    width: 68px;
    background: #FFFFFF;
    text-align: center;
    display: grid;
  }
  /deep/ .el-menu--horizontal>.el-menu-item.is-active{
     border-bottom: 2px solid #A70012 !important;
  }
  /deep/ .el-menu-item, .el-submenu__title{
    height: 45px;
    line-height: 56px;
    list-style: none;
    position: relative;
    white-space: nowrap;
  }
 /* /deep/ .el-menu--horizontal>.el-menu-item.is-active>.el-submenu{
    border-bottom: 2px solid #A70012 !important;
  }*/
  .logo{
    cursor: pointer;
    margin-top:30px;
  }
  .navBox{
    /*float: right;
    display: flex;
    position: relative;
    ul{
    padding:30px 0;   
    display: inline-block;
    li{
      float: left;
      margin-right: 65px;
      cursor: pointer;
      }
    }*/
    height: 115px;
    .mr42{
      margin-right: 42px;
    }
   .searchIcon{
      padding:50px 0;
      cursor: pointer;
    }
    .searchBox{
      z-index: 99;
      width: 226px;
      height: 42px;
      background: #F0F0F2;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      opacity: 0.8985;
      display: flex;
      position: absolute;
      top: 40px;
      right: 25px;
      input{
        font-size: 14px;
        color: #353535;
        line-height: 20px;
        letter-spacing: 1px;
        height: 42px;
        display: block;
        width: 175px;
        border: none;
        padding-left: 14px;
        outline:none; 
      }
      .deleteIcon{
        width: 10px;
        height: 10px;
        right: 66px;
        position: absolute;
        top:15px;
        cursor: pointer;
      }
      input::placeholder {
        font-size: 14px;
        letter-spacing: 1px;
        color: #353535;
    }
      .search{
        width: 50px;
        display: block;
        height: 42px;
        background: #900211;
        border-radius: 1px 0px 0px 1px;
        opacity: 0.8985;
        color: #F2F2F2;
        font-size: 14px;
        text-align: center;
        line-height: 42px;
        border:1px solid #E5D8DA;
        cursor: pointer;
      }
    }
  .changeLangage{
    position: absolute;
    right: 0;
    padding:50px 0;
    span{
      margin-left:7px;
      cursor: pointer;
      color: #9A9A9A; 
    }
    span:first-of-type{
      margin-right:7px;
    }
  }
  }
}
</style>
